'use client'

import Image from 'next/image'

import { CTA_FOOTER_TEST_IDS } from '@/shared/academy-test-ids.const'

import styles from './CtaFooter.module.scss'

interface CtaFooterProps {
  onTryGraftcode: () => void
}

export function CtaFooter({ onTryGraftcode }: CtaFooterProps) {
  return (
    <footer className={styles.footerSection} data-testid={CTA_FOOTER_TEST_IDS.root}>
      <div className={styles.ctaBanner}>
        <Image src="/images/cta-banner-bg.png" alt="" fill className={styles.ctaBannerBg} aria-hidden />
        <div className={styles.ctaContent}>
          <p className={styles.ctaTitle}>Stop wiring code.{'\n'}Start building faster.</p>
          <button className={styles.ctaButton} onClick={onTryGraftcode} type="button">
            Try Graftcode for free
          </button>
        </div>
      </div>
      <p className={styles.footerText}>© 2026 Graftcode, Inc. All Rights Reserved.</p>
    </footer>
  )
}
